import { Directive, OnInit, ElementRef, Renderer2, NgModule } from '@angular/core';

@Directive({
  selector: '[appRequired]',
  standalone: true,
})
export class MarkAsteriskDirective { // implements OnInit

  constructor(private el: ElementRef) {
    this.setup();
  }

  // constructor(private renderer: Renderer2, private el: ElementRef) {

  // }

  setup()
  {
    // const parent = this.renderer.parentNode(this.el.nativeElement);
    const parent = this.el.nativeElement.parentNode;

    if (parent.getElementsByTagName('LABEL').length && !parent.getElementsByClassName('required-asterisk').length) {
      // parent.getElementsByTagName('LABEL')[0].innerHTML += '<span class="required-asterisk">*</span>';
      const span = document.createElement('span');
      span.className = 'required-asterisk';
      span.innerHTML = '*';

      parent.append(parent.getElementsByTagName('label')[0]);
      parent.appendChild(span);
      if (parent.getElementsByTagName('input').length) {
        if (parent.getElementsByTagName('div').length && parent.getElementsByClassName('flex-container').length)
          parent.append(parent.getElementsByTagName('div')[0])
        else
          parent.appendChild(parent.getElementsByTagName('input')[0]);
      }
      else if (parent.getElementsByTagName('select').length)
        parent.appendChild(parent.getElementsByTagName('select')[0]);
    }
  }

  // ngOnInit() {
  //   const parent = this.renderer.parentNode(this.el.nativeElement);

  //   if (parent.getElementsByTagName('LABEL').length && !parent.getElementsByClassName('required-asterisk').length) {
  //     parent.getElementsByTagName('LABEL')[0].innerHTML += '<span class="required-asterisk">*</span>';
  //   }
  // }
}
